import { render, staticRenderFns } from "./proposal-26-brand-and-reputation.vue?vue&type=template&id=77da927e"
import script from "./proposal-26-brand-and-reputation.vue?vue&type=script&lang=js"
export * from "./proposal-26-brand-and-reputation.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports